import type { Action } from 'redux';
import type { IAdLink, ILinkTemplateRecord } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { AdLinkCreatorService } from '../../../../main/services/AdLinkCreatorService/AdLinkCreatorService';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { AdLinkCreatorState } from '../types/ReducerTypes';

const UpdateEditedAdLink = new ReduxAsyncAction<
  'UPDATE_EDITED_AD_LINK',
  { adLinkId: string; adLink: AdLinkCreatorState; domain: string; selectedTemplate?: ILinkTemplateRecord },
  { editedAdLink: IAdLink }
>('UPDATE_EDITED_AD_LINK');

UpdateEditedAdLink.registerRequest(
  async ({ adLinkId, adLink, domain, selectedTemplate }): Promise<{ editedAdLink: IAdLink }> => {
    try {
      const payload = AdLinkCreatorService.getAdLinkPayload({ ...adLink, domain });
      const templateId = selectedTemplate?.id;
      const templatePath = templateId ? `/template/${templateId}` : '';

      const response = await dash_api.put(`/v1/linkhub/ad/${adLinkId}${templatePath}`, payload);

      return { editedAdLink: response.data };
    } catch (error) {
      NotificationActions.showNotification('Failed to edit ad link.', 'error');
      throw error;
    }
  }
);

export const UPDATE_EDITED_AD_LINK = UpdateEditedAdLink.actionNamespaceConstants;
export const updateEditedAdLink = UpdateEditedAdLink.request;

export type UpdateEditedAdLinkResponseAction = Action<typeof UPDATE_EDITED_AD_LINK.response> & {
  data: { editedAdLink: IAdLink };
};
